import { Action } from '@ngrx/store';
import { BootstrapResponse, TermsAndConditions } from '@app/api/models/api-models';
import { HttpErrorResponse } from '@angular/common/http';

export enum TermsActionTypes {
  TERMS_CONDITIONS_ATTEMPT = '[TermsConditions] Terms Conditions Attempt',
  TERMS_CONDITIONS_FAILURE = '[TermsConditions] Terms Conditions Failure',
  TERMS_CONDITIONS_SUCCESS = '[TermsConditions] Terms Conditions Success',

  TERMS_CONDITIONS_UPDATE_ATTEMPT = '[TermsConditions] Terms Conditions Update Attempt',
  TERMS_CONDITIONS_UPDATE_FAILURE = '[TermsConditions] Terms Conditions Update Failure',
  TERMS_CONDITIONS_UPDATE_SUCCESS = '[TermsConditions] Terms Conditions Update Success',

  PURCHASE_NOT_FOUND = '[PurchaseNotFound] Purchase not found.',

  ESTABLISHMENT_IS_SUSPENDED = '[EstablishmentIsSuspended] Establishment is suspended.',

  FAILED_AUTHENTICATION = '[FailedAuthentication] Failed Authentication.',

  GET_ACTIONS = '[Actions] Get Actions.',
  GET_ACTIONS_SUCCESS = '[Actions] Get Actions Success.',
}

export class TermsConditionsAttempt implements Action {
  readonly type = TermsActionTypes.TERMS_CONDITIONS_ATTEMPT;
}

export class TermsConditionsSuccess implements Action {
  readonly type = TermsActionTypes.TERMS_CONDITIONS_SUCCESS;
  constructor(public payload: { response: any }) {}
}

export class TermsConditionsFailure implements Action {
  readonly type = TermsActionTypes.TERMS_CONDITIONS_FAILURE;
  constructor(public payload?: { error: HttpErrorResponse }) {}
}

export class TermsConditionsUpdateAttempt implements Action {
  readonly type = TermsActionTypes.TERMS_CONDITIONS_UPDATE_ATTEMPT;
}

export class TermsConditionsUpdateSuccess implements Action {
  readonly type = TermsActionTypes.TERMS_CONDITIONS_UPDATE_SUCCESS;
  constructor(public payload: { update: TermsAndConditions }) {}
}

export class TermsConditionsUpdateFailure implements Action {
  readonly type = TermsActionTypes.TERMS_CONDITIONS_UPDATE_FAILURE;
  constructor(public payload?: { error: HttpErrorResponse }) {}
}

export class PurchaseNotFound implements Action {
  readonly type = TermsActionTypes.PURCHASE_NOT_FOUND;
}

export class EstablishmentSuspended implements Action {
  readonly type = TermsActionTypes.ESTABLISHMENT_IS_SUSPENDED;
}

export class FailedAuthentication implements Action {
  readonly type = TermsActionTypes.FAILED_AUTHENTICATION;
}

export class GetActions implements Action {
  readonly type = TermsActionTypes.GET_ACTIONS;
  constructor(public payload: { response: BootstrapResponse; establishmentId: string }) {}
}

export class GetActionsSuccess implements Action {
  readonly type = TermsActionTypes.GET_ACTIONS_SUCCESS;
  constructor(public payload: { response: BootstrapResponse; businessUnitActions: any; userActions: any; upgradeActions: any }) {}
}

export type TermsActions =
  | TermsConditionsAttempt
  | TermsConditionsSuccess
  | TermsConditionsFailure
  | TermsConditionsUpdateAttempt
  | TermsConditionsUpdateSuccess
  | TermsConditionsUpdateFailure
  | PurchaseNotFound
  | EstablishmentSuspended
  | FailedAuthentication
  | GetActions
  | GetActionsSuccess;
